var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsideParties(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10229_1821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 20.65V0.35H0.35V20.65H20.65Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10229_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4182 12.4728C16.4182 14.6518 14.6518 16.4182 12.4728 16.4182C10.2938 16.4182 8.52734 14.6518 8.52734 12.4728C8.52734 10.2938 10.2938 8.52734 12.4728 8.52734C14.6518 8.52734 16.4182 10.2938 16.4182 12.4728Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.4998C20.2432 20.7566 19.8268 20.7566 19.57 20.4998L16.4514 17.3812C16.1946 17.1244 16.1946 16.708 16.4514 16.4512C16.7082 16.1944 17.1245 16.1944 17.3813 16.4512L20.5 19.5698C20.7568 19.8266 20.7568 20.243 20.5 20.4998Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3086 15.3086L16.4182 16.4182",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0762 17.7333L17.7337 17.0758",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7368 13.8068C14.968 13.4153 15.103 12.9603 15.103 12.4727C15.103 11.0201 13.9254 9.84246 12.4727 9.84246C11.9852 9.84246 11.5302 9.97748 11.1387 10.2087",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.209 11.1386C9.97784 11.5301 9.84277 11.9851 9.84277 12.4727C9.84277 13.9254 11.0204 15.103 12.4731 15.103C12.9607 15.103 13.4157 14.9679 13.8072 14.7367",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1166 17.4047V17.7333C14.1166 18.278 13.675 18.7197 13.1303 18.7197H1.29396C0.749192 18.7197 0.307617 18.278 0.307617 17.7333V2.6091C0.307617 2.06437 0.749192 1.62275 1.29396 1.62275H3.92425",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.62279H13.1304C13.6751 1.62279 14.1167 2.06441 14.1167 2.60913V7.54102",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19848 0.636828L8.19766 0.636007C7.98739 0.425754 7.70222 0.307636 7.40486 0.307637H7.01854C6.72118 0.307637 6.43603 0.425761 6.22575 0.636007L6.22493 0.636828C6.01467 0.847075 5.72952 0.965193 5.43218 0.965199H4.58139C4.21824 0.965199 3.92383 1.25961 3.92383 1.6228V2.93793H10.4996V1.6228C10.4996 1.25961 10.2052 0.965199 9.84201 0.965199H8.99127C8.6939 0.965199 8.40872 0.847074 8.19848 0.636828Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85636 16.4182H1.95183C1.86463 16.4182 1.781 16.3835 1.71934 16.3219C1.65769 16.2602 1.62305 16.1766 1.62305 16.0894V3.26666C1.62305 3.17946 1.65769 3.09583 1.71934 3.03417C1.781 2.97251 1.86463 2.93788 1.95183 2.93788H2.60939",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8154 2.9379H12.473C12.5602 2.9379 12.6438 2.97254 12.7055 3.0342C12.7671 3.09586 12.8018 3.17948 12.8018 3.26668V7.21198",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04785 1.6228H7.37663",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2666 5.56821L3.92416 6.22577L5.07494 5.07503",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55469 5.56818H10.8289",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2666 8.19852L3.92416 8.85608L5.07494 7.70534",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55469 8.19849H9.84254",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2666 10.8288L3.92416 11.4863L5.07494 10.3356",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55469 10.8288H7.21225",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2666 13.4591L3.92416 14.1166L5.07494 12.9659",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55469 13.459H7.21225",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideParties);
export default __webpack_public_path__ + "static/media/aside-parties.95c8208d5f736828c97dc1b028bbd828.svg";
export { ForwardRef as ReactComponent };